"use strict";
/**
 * requestAnimationFrame polyfill
 *
 * ### Example
 * ```
 * const id = raf(() => {});
 * cancelRaf(id);
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancel = exports.raf = void 0;
var prev = Date.now();
function fallback(fn) {
    var curr = Date.now();
    var ms = Math.max(0, 16 - (curr - prev));
    var id = setTimeout(fn, ms);
    prev = curr + ms;
    return id;
}
var self = window;
var iRaf = self.requestAnimationFrame
    || self.webkitRequestAnimationFrame
    || fallback;
var iCancel = self.cancelAnimationFrame
    || self.webkitCancelAnimationFrame
    || self.clearTimeout;
function raf(fn) {
    return iRaf.call(self, fn);
}
exports.raf = raf;
function cancel(id) {
    iCancel.call(self, id);
}
exports.cancel = cancel;
